import Keycloak from 'keycloak-js';

const CONFIG_FILE_PATH = `${window.REACT_APP_PUBLIC_PATH}/keycloak.json`;
const keycloak = new Keycloak(CONFIG_FILE_PATH);

export const keycloakConfig = {
  keycloak,
  loginOptions: {
    scope: 'openid offline_access',
  },
};

export default keycloak;
